<template>
  <div class="home-news">
    <header class="home-news-hd">
      <div
        class="news-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="news-hd-subTitle">最新动态</h4>
        <h2 class="news-hd-title">了解狄诺尼的最新资讯与活动</h2>
      </div>
    </header>
    <div class="classification">
      <div class="tabs">
        <div class="tabs-content">
          <el-tabs v-model="classification">
            <el-tab-pane
              :label="item.name"
              :name="item.value"
              v-for="item in tabList"
              :key="item.value"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="content">
      <template v-if="newsList.length == 0">
        <EmptyPage name="暂无数据" />
      </template>
      <template v-else>
        <div class="newsList">
          <div
            v-for="(item, index) in newsList"
            :key="index"
            class="newsCard"
            @click="openUrl(item)"
          >
            <div class="left">
              <div class="date">
                {{ item.publishDate.split("-").slice(1).join("-") }}
              </div>
              <br />
              <div class="year">
                {{ item.publishDate.split("-")[0] }}
              </div>
            </div>

            <div class="line"></div>

            <div class="text">
              <div class="title">{{ item.title }}</div>

              <div class="summary">{{ item.summary }}</div>
            </div>

            <img class="thumbnail" :src="item.picUrl" alt="轮播图" />
          </div>
        </div>

        <div style="margin: 0 auto; padding-bottom: 80px; width: fit-content">
          <Pagination
            layout="prev, pager, next"
            :isPadding="true"
            :page.sync="queryInfo.pageNum"
            :limit.sync="queryInfo.pageSize"
            :total="total"
            @pagination="handleSizeChange"
          ></Pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import EmptyPage from "@/components/EmptyPage.vue";

import { infoManageApi } from "@/api/website";
export default {
  name: "newsIndex",
  props: {},
  components: {
    EmptyPage,
    Pagination,
  },
  data() {
    return {
      total: 120,
      classification: "1",
      tabList: [
        {
          name: "全部",
          value: "0",
        },
        {
          name: "资讯",
          value: "1",
        },
        {
          name: "视频",
          value: "2",
        },
      ],
      newsList: [],
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
      },
    };
  },
  computed: {},
  watch: {
    classification(newV) {
      this.queryInfo.pageNum = 1;
      this.getNewsList();
    },
  },
  created() {},
  mounted() {
    let classification = this.$route.query.classification;
    if (classification) this.classification = classification;
    let page = this.$route.query.page;
    if (page) this.queryInfo.pageNum = Number(page);

    this.getNewsList();
  },
  methods: {
    getNewsList() {
      let params = {
        current: this.queryInfo.pageNum,
        size: 10,
        type: this.classification === "0" ? "1,2" : this.classification,
      };
      infoManageApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          let nowTimeString = this.$uniFun.getNowTime();
          let temp = res.data.records.filter(
            (item) =>
              nowTimeString > item.effectiveTime && item.startupStatus === "2",
          ); // 查找出已启用且生效的数据
          this.newsList = temp.map((item) => {
            return {
              id: item.id,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              linkUrl: "",
              title: item.title,
              publishDate: item.effectiveTime.split(" ")[0],
              summary: item.subtitle,
            };
          });
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(e) {
      this.queryInfo.pageNum = e.pageIndex;
      this.getNewsList();
    },
    openUrl(item) {
      this.$uniFun.openInCurrentTab(
        // item.linkUrl + `?id=` + item.id + `&page=` + this.queryInfo.pageNum
        `/pc_index/newsDetail?&id=${item.id}&classification=${this.classification}&page=${this.queryInfo.pageNum}`,
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.home-news {
  background: white;
  .home-news-hd {
    width: 100%;
    height: 200px;
    background: url("~@/views/web/home/imgs/newsBanner.png") no-repeat center;
    background-size: cover;
    .news-hd-wrapper {
      width: 1200px;
      margin: 0 auto;
      padding-top: 50px;
      .news-hd-subTitle {
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        line-height: 27px;
        font-style: normal;
      }
      .news-hd-title {
        font-weight: bold;
        font-size: 28px;
        color: #fff;
        line-height: 28px;
        font-style: normal;
      }
    }
  }
}

.selected {
  width: fit-content;
  height: 64px;
  font-weight: bold;
  font-size: 18px;
  color: #1d1d1f;
  line-height: 64px;
  text-align: center;
  font-style: normal;
  border-bottom: 2px solid #0035fb;
  cursor: pointer;
}
.normal {
  width: fit-content;
  height: 64px;
  font-weight: 400;
  font-size: 18px;
  color: #1d1d1f;
  line-height: 64px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 44px; /* 卡片之间的间距 */
  justify-content: space-between; /* 水平方向平均分布 */
}
.newsList {
  width: fit-content;
  margin: 0 auto;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 40px 0;

  .newsCard {
    width: 100%;
    height: 220px;
    border-bottom: 1px solid #dbdbdb;
    display: flex;
    gap: 24px;
    cursor: pointer;
    .left {
      width: 54px;
      color: #999999;
      text-align: right;
      .date {
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        margin-top: 20px;
      }
      .year {
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
      }
    }
    .line {
      width: 24px;
      height: 1px;
      background: #d9d9d9;
      margin-top: 28px;
    }

    .text {
      padding: 16px 0;
      // flex: 1;
      width: 730px;
      .title {
        margin-bottom: 16px;
        @extend .text-truncate-multiline;
        --line-clamp: 2;
        width: 100%;
        // height: 48px;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        text-align: left;
      }

      .summary {
        width: 100%;
        height: auto;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        // text-indent: 2em;
        @extend .text-truncate-multiline;
        --line-clamp: 7;
      }
    }

    .thumbnail {
      width: 320px;
      height: 180px;
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      .thumbnail {
        transform: scale(1.05);
      }
      .title {
        color: #0035fb;
      }
    }
  }
}
</style>
<style lang="scss">
.classification {
  position: sticky;
  left: 0;
  top: 80px;
  padding-left: calc(50% - 600px);
  width: 100%;
  height: 64px;
  margin: 0 auto;
  border-bottom: 1px solid #dbdbdb;
  display: flex;
  gap: 40px;
  background: #fff;
  .tabs {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #d8d8d8;
    .el-tabs__nav-wrap::after {
      display: none !important;
    }
    .el-tabs__item {
      color: #333333 !important;
      font-size: 18px !important;
      opacity: 0.8;
    }
    .el-tabs__item.is-active {
      font-weight: bold !important;
      opacity: 1;
    }
    .el-tabs__item:hover {
      color: #333333 !important;
      opacity: 1;
    }
    .el-tabs__active-bar {
      background-color: #0035fb !important;
    }
    .tabs-content {
      padding: 0;
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
    }
  }
}
</style>
